export const ALLOWED_LANGUAGES = ['en', 'uk', 'ru']

export const DEFAULT_LANG = 'uk'
